<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">开单打卡&nbsp;/&nbsp;</span>
      </div>
      <div>离职记录</div>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <div class="member-header space-between">
            <div class="flex-row">
              <el-select v-model="query.auditStatus" placeholder="审核状态" filterable @change="selectChange">
                <el-option label="全部状态" value></el-option>
                <el-option label="待审核" value="wait"></el-option>
                <el-option label="处理中" value="processing"></el-option>
                <el-option label="通过" value="pass"></el-option>
                <el-option label="拒绝" value="refuse"></el-option>
                <el-option label="取消" value="cancel"></el-option>
              </el-select>
            </div>
            <el-button type="primary" @click="addList" v-perm="{key:'attendancePunch', value: 'attendancePunch:quit'}">离职申请</el-button>
          </div>
          <div class="plr16">
            <el-table :data="list" :max-height="height - 265" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="staffName" label="店员姓名"></el-table-column>
              <el-table-column prop="auditStatusCn" label="审核状态" width="auto"></el-table-column>
              <el-table-column prop="quitCateName" width="auto" label="离职原因"></el-table-column>

              <el-table-column prop="oxCtime" label="申请时间" width="170px">
                <template slot-scope="scope">{{ formatDate(scope.row.oxCtime) }}</template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                    <el-link type="primary" @click="leaveRequest(scope.row)">详情</el-link>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <detail ref="detailForm" @change="onBack"></detail>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import detail from "../staffManage/companyQuit.vue"
export default {
  data() {
    return {
      url: this.$url.companyQuit.list,
      query: {
        auditStatus: "",
        start: 0,
        size: 20
      },
      height: this.$store.getters.MainHeight,
      list: []
    };
  },
  mixins: [minxin],
  components: {detail},
  computed: {},

  created() {
    this.totalCounts();
  },
  mounted () {
    this.$nextTick(() => {
      if (sessionStorage.getItem("attendanceParmas")) {
        this.$refs["detailForm"].$emit("set", true);
      }
    })
  },
  methods: {
    leaveRequest (row) {
      console.log(row);
      row.source = "staff";
      this.$refs["detailForm"].$emit("set", row);
    },
    addList () {
      
      this.$refs["detailForm"].$emit("set", JSON.parse(localStorage.getItem("shopInfo")));
    },
    handleChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    back() {
      if (sessionStorage.getItem("goBack")) {
        let url = sessionStorage.getItem("goBack");
        this.$router.push(url);
        sessionStorage.removeItem("goBack");
      } else {
        this.$router.push("/dataList/attendancePunch");
      }
      
    },
    selectChange() {
      this.query.start = 0;
      this.totalCounts();
    },
    onBack (org) {
      if (org) this.getData();
    },
    totalCounts () {
      this.$api.post(this.$url.companyQuit.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  height: calc(100% - 72px);
  .member-content-box {
    background: #fff;
  }
  .member-header {
    
    padding: 16px;
    display: flex;
  }
}
</style>

